import React from 'react';
export var Card = function Card(_ref) {
  var _ref$url = _ref.url,
    url = _ref$url === void 0 ? '' : _ref$url,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? function (_error) {} : _ref$onError,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null) : _ref$children;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "smart-card-".concat(url)
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onError({
        status: 'not_found'
      });
    }
  }, "Trigger not_found error status"), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onError({
        status: 'unauthorized'
      });
    }
  }, "Trigger unauthorized error status"), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onError({
        status: 'forbidden'
      });
    }
  }, "Trigger forbidden error status"), children);
};
export var CardSSR = Card;
export var MetadataBlock = function MetadataBlock(_ref2) {
  var _ref2$primary = _ref2.primary,
    primary = _ref2$primary === void 0 ? [] : _ref2$primary;
  return /*#__PURE__*/React.createElement("div", null, primary.map(function (_ref3) {
    var name = _ref3.name;
    return /*#__PURE__*/React.createElement("div", {
      key: name
    }, "Primary metadata: ", name);
  }));
};
export var CustomBlock = function CustomBlock(_ref4) {
  var _ref4$children = _ref4.children,
    children = _ref4$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null) : _ref4$children;
  return /*#__PURE__*/React.createElement("div", null, "CustomBlock", children);
};
export var PreviewBlock = function PreviewBlock(_ref5) {
  var _ref5$overrideUrl = _ref5.overrideUrl,
    overrideUrl = _ref5$overrideUrl === void 0 ? 'NONE' : _ref5$overrideUrl;
  return /*#__PURE__*/React.createElement("div", null, "Preview: ", overrideUrl);
};
export var SnippetBlock = function SnippetBlock(_ref6) {
  var _ref6$text = _ref6.text,
    text = _ref6$text === void 0 ? '' : _ref6$text;
  return /*#__PURE__*/React.createElement("div", null, "Snippet: ", text);
};
export var TitleBlock = function TitleBlock(_ref7) {
  var _ref7$metadata = _ref7.metadata,
    metadata = _ref7$metadata === void 0 ? [] : _ref7$metadata,
    _ref7$text = _ref7.text,
    text = _ref7$text === void 0 ? '' : _ref7$text;
  return /*#__PURE__*/React.createElement("div", null, !!text ? text : 'TitleBlock', metadata.map(function (_ref8) {
    var name = _ref8.name;
    return /*#__PURE__*/React.createElement("div", {
      key: name
    }, "Metadata: ", name);
  }));
};
export var mockHubRouteProps = {
  actions: {
    onLogoutClick: function onLogoutClick() {
      return {
        type: 'epic.logout.LOG_OUT'
      };
    }
  },
  env: {
    cloudId: '17554ffe-ef18-4562-8222-e295e81a46bb',
    helpCenterAri: 'ari:cloud:help::help-center/5b32ba66-fea2-4010-893d-278bfac050bc/5e67e6f9-7753-41fa-811b-55cb9fd71897',
    helpCenterId: '5e67e6f9-7753-41fa-811b-55cb9fd71897',
    hoistedProjectKey: 'TR',
    hubEditMode: false,
    jiraDisplayUrl: '/',
    relativeBaseUrl: '/'
  },
  layout: {
    bannerText: '',
    isAnonymousRoute: false,
    showBanner: false
  },
  user: {
    avatarSrc: '',
    displayName: 'test_name',
    email: 'test@atlassian.com',
    id: 'some_random_id',
    isJiraAdmin: false
  }
};